// Utility function to properly format timestamps from Supabase
export const formatSnapshotTime = (dateString, isFromDatabase = false) => {
  if (!dateString) return 'N/A';
  
  // Check if it's already a formatted string (from frontend)
  if (typeof dateString === 'string' && dateString.includes(' - ')) {
    return dateString.replace(' - ', ' at ');
  }
  
  let date;
  
  try {
    // Handle different timestamp formats from database
    if (typeof dateString === 'string') {
      // Handle ISO format with +00:00 timezone like "2025-07-05T12:35:00+00:00"
      if (dateString.includes('+00:00')) {
        // Convert to standard UTC format
        const isoString = dateString.replace('+00:00', 'Z');
        date = new Date(isoString);
      }
      // Handle Supabase format like "2025-07-05 12:35:00+00" or "2025-07-06 08:19:00+00"
      else if (dateString.includes('+00')) {
        // Convert to ISO format for proper parsing - ensure we treat as UTC
        const isoString = dateString.replace(' ', 'T').replace('+00', 'Z');
        date = new Date(isoString);
      } 
      // Handle Supabase format without timezone like "2025-07-05 12:35:00"
      else if (dateString.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/)) {
        // Assume UTC and add Z
        const isoString = dateString.replace(' ', 'T') + 'Z';
        date = new Date(isoString);
      }
      // Handle standard ISO format like "2025-07-06T08:19:00.000Z"
      else if (dateString.includes('T') && (dateString.includes('Z') || dateString.includes('+'))) {
        date = new Date(dateString);
      }
      // Handle any other format by treating as UTC
      else {
        // For any other string format, try to parse and ensure UTC interpretation
        const finalString = dateString + (dateString.includes('Z') || dateString.includes('+') ? '' : 'Z');
        date = new Date(finalString);
      }
    } else {
      date = new Date(dateString);
    }
    
    // Check if date is valid
    if (isNaN(date.getTime())) {
      console.error('Invalid date:', dateString);
      return `Invalid Date (${dateString})`;
    }
    
    // Use a simpler approach to avoid any potential issues with Intl.DateTimeFormat
    // that might return objects instead of strings in some edge cases
    // Use toLocaleDateString and toLocaleTimeString separately to ensure string output
    const dateStr = date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
    
    const timeStr = date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
    
    const result = `${dateStr} at ${timeStr}`;
    
    // Final safety check to ensure we're returning a string
    if (typeof result !== 'string') {
      console.error('Date formatting returned non-string:', result);
      // Ultimate fallback
      return date.toString();
    }
    
    return result;
    
  } catch (error) {
    console.error('Error formatting date:', error, 'Original dateString:', dateString);
    // Fallback to basic date formatting
    try {
      const fallbackDate = new Date(dateString);
      if (!isNaN(fallbackDate.getTime())) {
        return fallbackDate.toString();
      }
    } catch (fallbackError) {
      console.error('Fallback date formatting also failed:', fallbackError);
    }
    return `Error formatting date: ${dateString}`;
  }
};
